import { CellProps } from 'react-table'
import { AtendimentoPacienteList } from '../../../../atendimento/core/_models'
import { HistoricoActionsCell } from './HistoricoActionsCell'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { PlainHeader, sortableColumn, StackedCell, TableColumn } from '../../../../../../components'
import { TFunction } from '_metronic/i18n/Metronici18n'

const HistoricoColumns = (t: TFunction): ReadonlyArray<TableColumn<AtendimentoPacienteList>> => [
  // Protocolo com a especialidade como apoio; os dois seguem ordenáveis, como antes.
  sortableColumn<AtendimentoPacienteList>({
    id: 'protocolo',
    useQueryRequest,
    fields: [
      { field: 'protocolo', label: t('cols.protocolo') },
      { field: 'especialidade', label: t('cols.especialidade') },
    ],
    Cell: ({ row }: CellProps<AtendimentoPacienteList>) => (
      <StackedCell
        tabular
        primary={row.original.protocolo}
        secondary={row.original.especialidade?.nome}
      />
    ),
  }),
  sortableColumn<AtendimentoPacienteList>({
    id: 'estado.descricao',
    cellWidth: '200px',
    useQueryRequest,
    fields: [{ field: 'estado.descricao', label: t('cols.estado') }],
    Cell: ({ row }: CellProps<AtendimentoPacienteList>) => (
      <StackedCell primary={row.original.estado?.descricao} />
    ),
  }),
  sortableColumn<AtendimentoPacienteList>({
    id: 'solicitacao',
    cellWidth: '170px',
    hideOnMobile: true,
    useQueryRequest,
    fields: [{ field: 'solicitacao', label: t('cols.agendamento') }],
    Cell: ({ row }: CellProps<AtendimentoPacienteList>) => (
      <StackedCell tabular primary={row.original.solicitacaoFormatada} />
    ),
  }),
  {
    Header: () => <PlainHeader>{t('cols.actions')}</PlainHeader>,
    id: 'actions',
    cellWidth: '104px',
    align: 'end',
    Cell: ({ row }: CellProps<AtendimentoPacienteList>) => (
      <HistoricoActionsCell atendimento={row.original} />
    ),
  },
]

export { HistoricoColumns }
